export enum AddCustomerToDossierState {
	SAVED = "",
}
